import * as get from './get';

export default {
  ...get,
};
